module.exports = __webpack_public_path__ + "static/survival_hours-b69f52a52b8fca2a3e43a8698f51a305.jpg";